import React from 'react'
import PropTypes from 'prop-types'

import TableSplitButton from '~/components/TableSplitButton'
import useDeleteConfirm from '~/components/TableSplitButton/useDeleteConfirm'

function BulkActionButton ({ onAdjustmentsDelete, loading }) {
  const { handleClick } = useDeleteConfirm()

  const options = [
    {
      label: 'Delete',
      'data-cy': 'deleteMenu',
      onMenuClick: () => handleClick(onAdjustmentsDelete)
    },
  ]

  return (
    <TableSplitButton
      options={options}
      name="adjustment"
      loading={loading}
    />
  )
}

BulkActionButton.propTypes = {
  onAdjustmentsDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default BulkActionButton
